<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
import LastComments from 'components/Blog/LastComments.vue'
import LastCommentsMobile from 'components/Blog/LastCommentsMobile.vue'
import LastLives from 'components/LastLives.vue'
</script>
<template>
    <MainLayout>
        <div class="slot-body">
            <div class="container">
                <div class="row not-live align-items-center" v-if="showNotLive">
                    <div class="col-12 text-center py-5">
                        <h1 class="title"> {{ translate.msgNotLive1 }}</h1>
                        <p class="text"> {{ translate.msgNotLive2 }}</p>
                        <br>
                        <router-link :to="{
                            name: 'homePage',
                            params: {
                                locale: locale ?? 'pt-br'
                            }
                        }">
                            <p class=""> {{ translate.msgNotLive3 }}</p>
                        </router-link>
                    </div>
                </div>
                <div class="row live" v-if="showLive">
                    <div class="col-xl-9 col-12 order-xl-1 order-2">
                        <div class="row">
                            <p class="subtitle" v-html="translate.msgLive1"></p>
                            <p class="subtitle" v-html="translate.msgLive2"></p>
                            <p class="subtitle" v-html="translate.msgLive3"></p>
                            <p class="subtitle" v-html="translate.msgLive4"></p>
                            <p class="subtitle" v-html="translate.msgLive5"></p>
                            <h1 class="title">Live {{ numberLive }}</h1>
                        </div>
                        <div class="row">
                            <iframe v-if="showDacast" id="37c462f6-8ac6-70ba-cb02-8e1a9770b037-live-67b2b873-6726-838e-957c-2c62c515bc0b"
                                src="https://iframe.dacast.com/live/37c462f6-8ac6-70ba-cb02-8e1a9770b037/67b2b873-6726-838e-957c-2c62c515bc0b"
                                height="515" frameborder="0" scrolling="no" allow="autoplay;encrypted-media" allowfullscreen
                                webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen>
                            </iframe>
                        </div>
                        <div class="row d-flex align-items-center">
                            <BoxVideo v-if="showLastLive" :video="videoSelect" />
                        </div>
                        <div class="row">
                            <LastLives v-if="lastLives.length > 0" :lives="lastLives" @loadLive="loadLive" />
                            <div v-else class="live-video-thumb col-xl-3 col-6">
                                <p class="text-card">Live 1</p>
                                <img :src="imgComingSoon" alt="Live">
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-12 order-xl-2 order-1 mb-3">
                        <LastComments :translate="translateComments" v-if="!isMobile()" />
                        <LastCommentsMobile :translate="translateComments" v-else />
                    </div>
                </div>
            </div>
        </div>
    </MainLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import api from '../../api'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import router from '../../router'
import tradutor from 'tradutors/live'
import translaters from 'tradutors/blogs';
import { isMobile } from 'views/shared/utils/mobile'
import BoxVideo from 'components/Model/BoxLive.vue'

export default defineComponent({
    name: 'LiveView',
    computed: {
        ...mapState(localeStore, ['locale']),
        translate: function () {
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        },
        translateComments: function () {
            if (this.locale === 'pt-br') {
                return translaters.portugues
            } else {
                return translaters.ingles
            }
        },
    },
    head() {
        return {
            templateParams: {
        subTitle: null, 
                subPage: 'Live',
                page_url: window.location.origin + this.$route.fullPath,
                page_description: this.locale == 'pt-br' ?
                `Acompanhe em tempo real os bastidores dos ensaios, sem censura, completo, mostrando tudo que nós gostamos de ver.` :
                `Follow behind the scenes of the photo shoot in real time, uncensored, complete, showing everything we like to see.`,
                page_image: '/favicon.ico',
                page_keywords: 'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
                page_locale: this.locale,
                page_url_pt: "https://belladasemana.com.br/pt-br/live",
                page_url_en: "https://belladasemana.com.br/en/live",
                page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,            
            }
        }
    },
    data() {
        return {
            showNotLive: false,
            showLive: false,
            showDacast: true,
            lastLives: [],
            showLastLive: false,
            videoSelect: '',
            numberLive: '',
            imgComingSoon: ''
        }
    },
    watch: {
        'locale': function () {
            this.imgComingSoon = `https://api.belladasemana.com.br/assets/img/live_video_coming_thumb_${this.locale ?? 'pt-br'}.jpg`
        }
    },
    mounted() {
        this.imgComingSoon = `https://api.belladasemana.com.br/assets/img/live_video_coming_thumb_${this.locale ?? 'pt-br'}.jpg`
    },
    created() {
        this.getLastLives()
    },
    methods: {
        getLastLives() {
            api.get(`v1/live/getLastLives?language=${this.locale}`).then(({ data }) => {
                if (data.returnStatus == 1) {
                    this.redirect('AssineOptionsPage')
                } else if (data.returnStatus == 2) {
                    this.showNotLive = true
                } else {
                    this.showLive = true
                    this.lastLives = data.lastLives
                }
            }).catch((error) => console.log(error))
        },
        redirect(name) {
            router.push({
                name,
                params: {
                    locale: this.locale ?? 'pt-br'
                }
            })
        },
        loadLive(data) {
            this.showLastLive = data.show
            this.videoSelect = data.file
            this.numberLive = data.file.number
            this.showDacast = false
        }
    }
})
</script>

<style scoped lang="css">
.slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
    font-size: 20px;
}

.title {
    margin-top: 30px;
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 48px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
}

.text {
    margin-top: 30px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 36px;
    letter-spacing: 0;
    line-height: 25px;
}

.text-card {
    margin-top: 30px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 24px;
    letter-spacing: 0;
    line-height: 25px;
}

.subtitle {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 25px;
}

.not-live {
    min-height: 400px;
}

.live {
    padding-top: 30px;
    padding-bottom: 50px;
}

#a656f0b6-0346-80b4-5581-cbdaec283443 {
    width: 100%;
}

.live-video-thumb img {
    width: 100%;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {

    .title {
        font-size: 36px;
    }

    #a656f0b6-0346-80b4-5581-cbdaec283443 {
        height: 228px;
    }

    .live {
        padding-top: unset;
    }

}
</style>